import permissions from "./permissions"

export const MetricBlueprintDropdownOptions = ["$", "%", "#", "N/A"]

export const MetricGoalsYears = [
  {
    label: "2024",
  },
  {
    label: "2023",
  },
  {
    label: "2022",
  },
  {
    label: "2021",
  },
  {
    label: "2020",
  },
]

export const AddNewBucketColumns: any = [
  {
    column_id: 1,
    column_name: "Month Actual",
    column_datatype: null,
  },
  {
    column_id: 2,
    column_name: "Month Goal",
    column_datatype: null,
  },
  {
    column_id: 3,
    column_name: "Month Projected",
    column_datatype: null,
  },
  {
    column_id: 4,
    column_name: "Month Projected vs Goal",
    column_datatype: null,
  },
  {
    column_id: 5,
    column_name: "Year Actual",
    column_datatype: null,
  },
  {
    column_id: 6,
    column_name: "Yeal Goal",
    column_datatype: null,
  },
  {
    column_id: 7,
    column_name: "Year Projected",
    column_datatype: null,
  },
  {
    column_id: 8,
    column_name: "Year Projected vs Goal",
    column_datatype: null,
  },
  {
    column_id: 9,
    column_name: "PYTC vs CYTD",
    column_datatype: null,
  },
  {
    column_id: 10,
    column_name: "PY vs TTM",
    column_datatype: null,
  },
  {
    column_id: 11,
    column_name: "Trend",
    column_datatype: null,
  },
  {
    column_id: 12,
    column_name: "Current",
    column_datatype: null,
  },
  {
    column_id: 13,
    column_name: "Current % of Total",
    column_datatype: null,
  },
  {
    column_id: 14,
    column_name: "Current Goal",
    column_datatype: null,
  },
  {
    column_id: 15,
    column_name: "Current Trend Average",
    column_datatype: null,
  },
  {
    column_id: 16,
    column_name: "Current Trend Average %",
    column_datatype: null,
  },
  {
    column_id: 17,
    column_name: "Current vs TTM Average",
    column_datatype: null,
  },
]

export const DefaultMetricHeaders = [
  {
    column_id: "month_actual",
    column_name: "Month Actual",
    headerPaddingTop: "17px",
  },
  {
    column_id: "month_goal",
    column_name: "Month Goal",
    headerPaddingTop: "17px",
  },
  {
    column_id: "month_projected",
    column_name: "Month Projected",
    headerPaddingTop: "17px",
  },
  {
    column_id: "month_projected_vs_goal",
    column_name: "Month Projected Vs Goal",
  },
  {
    column_id: "year_actual",
    column_name: "Year Actual",
    headerPaddingTop: "17px",
  },
  {
    column_id: "year_goal",
    column_name: "Year Goal",
    headerPaddingTop: "17px",
  },
  {
    column_id: "year_projected",
    column_name: "Year Projected",
    headerPaddingTop: "17px",
  },
  {
    column_id: "year_projected_vs_goal",
    column_name: "Year Projected Vs Goal",
  },
  {
    column_id: "trend",
    column_name: "Trend",
    headerPaddingTop: "17px",
  },
  {
    column_id: "cytd_vs_pytd",
    column_name: "CYTD Vs PYTD",
    headerPaddingTop: "17px",
  },
  {
    column_id: "ttm_vs_py",
    column_name: "TTM Vs PY",
    headerPaddingTop: "17px",
  },
  {
    column_id: "current_actual",
    column_name: "Current Actual",
    headerPaddingTop: "17px",
  },
  {
    column_id: "current_percent_of_total",
    column_name: "Current Percent Of Total",
  },
  {
    column_id: "current_goal",
    column_name: "Current Goal",
    headerPaddingTop: "17px",
  },
  {
    column_id: "current_trend",
    column_name: "Current Trend",
    headerPaddingTop: "17px",
  },
  {
    column_id: "current_trend_percent_of_total",
    column_name: "Current Trend Percent Of Total",
  },
  {
    column_id: "current_vs_ttm_average",
    column_name: "Current Vs Ttm Average",
  },
]

export const metricHeaderPaddingByColumnId = Object.fromEntries(
  DefaultMetricHeaders.filter((col) => col.headerPaddingTop).flatMap((col) => {
    const entries: [string, string][] = [[col.column_id, col.headerPaddingTop!]]

    // legacy column ids still returned by some buckets
    if (col.column_id === "cytd_vs_pytd") {
      entries.push(["pytd_vs_cytd", col.headerPaddingTop!])
    }
    if (col.column_id === "ttm_vs_py") {
      entries.push(["py_vs_ttm", col.headerPaddingTop!])
    }

    return entries
  }),
) as Record<string, string>

export const MetricGoalsMonths: any = {
  jan: 1,
  feb: 2,
  mar: 3,
  apr: 4,
  may: 5,
  june: 6,
  july: 7,
  aug: 8,
  sep: 9,
  oct: 10,
  nov: 11,
  dec: 12,
}

export { permissions }
